export const SET_AUTH = 'SET_AUTH';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const SET_CLIENT_PERSONAL = 'SET_CLIENT_PERSONAL';
export const FETCH_CLIENT_PAYMENT = 'FETCH_CLIENT_PAYMENT';
export const SET_CLIENT_PAYMENT = 'SET_CLIENT_PAYMENT';
export const ERROR_CLIENT_PAYMENT = 'ERROR_CLIENT_PAYMENT';
export const SET_CLIENT_PRODUCTS = 'SET_CLIENT_PRODUCTS';
export const CLIENT_PRODUCTS_LOADING = 'CLIENT_PRODUCTS_LOADING';
export const SET_BILLING_DOMAIN = 'SET_BILLING_DOMAIN';
export const INVALID_LOGIN = 'INVALID_LOGIN';
export const CLEAR_INVALID_LOGIN = 'CLEAR_INVALID_LOGIN';
export const SET_CONTRACT_PERIOD = 'SET_CONTRACT_PERIODS';
export const SET_RECEIPT_INFO = 'SET_RECEIPT_INFO';
export const SET_CLIENT_CONTACTS = 'SET_CLIENT_CONTACTS';
export const CLIENT_CONTACTS_LOADING = 'CLIENT_CONTACTS_LOADING';
export const SET_MIGRATION_STATUS = 'SET_MIGRATION_STATUS';
